export default __webpack_public_path__ + "static/media/malika.04ec5a1d.jpg";